module.exports = __webpack_public_path__ + "static/21-2550369555919ad2e63d4ff538950ada.png";